/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext } from "react";

import {
  AnalyzeTinybirdResourceResponseBodyType,
  ExperienceDto,
  ExperienceFe,
  GraphConfig,
  VariationDto,
} from "@intelligems/ig-types";
import { DashboardPageName } from "@src/api/types/dashboards";
import { UseQueryResult } from "@tanstack/react-query";

export type ShareTab = "results" | "configure-analytics";

export interface ShareDashboardFilters {
  hiddenStartTime: number;
  hiddenEndTime: number;
  compareVariationId: string;
}

export interface ShareAnalyticsContextValue {
  experience: ExperienceDto;
  experienceFe: ExperienceFe;
  variations: VariationDto[];
  analyticsData: UseQueryResult<AnalyzeTinybirdResourceResponseBodyType>[];
  currencyConfig: { code: string; locale: string };
  dashboardFilters: ShareDashboardFilters;
  graphConfigs: GraphConfig[];
  isLoading: boolean;
  // NEW: Fields for full AnalyticsDashboard compatibility
  experienceTotals: {
    visitors: number;
    orders: number;
    revenue: number | null;
  };
  testDuration: number;
  latestRunTs: number | undefined;
  timezone: string;
  pageName: DashboardPageName;
  organization: { timezone: string };
  availablePages: DashboardPageName[];
  activeTab: ShareTab;
  showConfigureAnalytics: boolean;
}

const ShareAnalyticsContext = createContext<
  ShareAnalyticsContextValue | undefined
>(undefined);

export const useShareAnalyticsContext = () => {
  const context = useContext(ShareAnalyticsContext);
  if (!context) {
    throw new Error(
      "useShareAnalyticsContext must be used within ShareAnalyticsProvider"
    );
  }
  return context;
};

export const ShareAnalyticsProvider: React.FC<{
  value: ShareAnalyticsContextValue;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return (
    <ShareAnalyticsContext.Provider value={value}>
      {children}
    </ShareAnalyticsContext.Provider>
  );
};
